<template>
  <v-card
    class="mx-auto pa-4"
    width="450px"
  >
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <p class="text-2xl font-weight-semibold text--primary">
            Falta pouco!
          </p>

          <span>Encontramos sua conta, só precisamos de mais alguns dados pra liberar o atendimento.</span>
        </v-col>
      </v-row>

      <v-form
        ref="formRef"
        @submit.prevent="handleSubmitBtnClick"
      >
        <v-text-field
          v-model="dados.nome"
          class="my-3"
          dense
          outlined
          maxlength="50"
          label="Nome"
          placeholder="Nome"
          hide-details="auto"
          :rules="[validators.required]"
        />

        <v-text-field
          v-model="dados.cpf"
          v-mask="'###.###.###-##'"
          class="mb-3"
          dense
          outlined
          label="CPF"
          autocomplete="cpf"
          hide-details="auto"
          :rules="[validators.required, validators.isCpfValido]"
        />

        <v-text-field
          v-model="dados.celular"
          v-mask="'(##) #####-####'"
          class="mb-3"
          dense
          outlined
          label="Celular"
          hide-details="auto"
          autocomplete="celular"
          :rules="[validators.isTelefoneCelularValido]"
        />

        <v-row>
          <v-col cols="12">
            <v-btn
              color="primary"
              block
              type="submit"
            >
              <v-progress-circular
                v-if="loading"
                indeterminate
                color="secondary"
              />
              <span v-else>Concluir cadastro</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue'
import { ref } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { required } from '@core/utils/validation'
import router from '@/router'
import AuthService from '@/services/modules/AuthService'
import AutoatendimentoService from '@/services/modules/AutoatendimentoService'
import useForm from '@/composables/useForm'
import useCentralStore from '@/store/central'
import { EventBus } from '@/components/event-bus/event-bus'
import { isCpfValido, isTelefoneCelularValido } from '@/utils/validation'

export default {
  setup() {
    const { empresaNomeFormatado, autoatendimentoNomeFormatado, requestUrl } = storeToRefs(useCentralStore())
    const { setCentralData, updateTitle } = useCentralStore()
    const { formRef, loading } = useForm()

    const dados = ref({ urlAlias: requestUrl.value, nome: '', cpf: '', celular: '' })

    async function getCentralData() {
      if (!requestUrl.value) return
      const autoatendimento = await AutoatendimentoService.getAutoatendimentoByUrlAlias(requestUrl.value)
      setCentralData(autoatendimento)
      updateTitle()
    }

    async function handleSubmitBtnClick() {
      if (loading.value) return

      if (!formRef.value.validate()) {
        Vue.$toast.warning('Preencha os campos corretamente antes de enviar.')
        return
      }

      try {
        loading.value = true

        await AuthService.completarCadastroAutoatendimento(dados.value)

        await getCentralData()
        EventBus.$emit('logged-in')

        router.push({
          name: 'autoatendimentoView',
          params: {
            empresaNomeFormatado: empresaNomeFormatado.value,
            autoatendimentoNomeFormatado: autoatendimentoNomeFormatado.value,
          },
        })
      } finally {
        loading.value = false
      }
    }

    return {
      formRef,
      loading,
      dados,
      handleSubmitBtnClick,
      validators: {
        required,
        isCpfValido,
        isTelefoneCelularValido,
      },
    }
  },
}
</script>
